<template>
    <div>
        <div class="title">Edit Sms Campaign {{ campaign.id }}</div>
        <edit-sms-campaign
            :campaign="campaign"
            :submit-loading="submitLoading"
            @updateCampaign="updateSmsCampaign"
            @cancel="returnToInfoList"
        />
        <alert :show-alert="alert.show" :message="alert.message" :type="alert.type" />
    </div>
</template>

<script>
    import smsCampaignService from '@/services/sms-campaign-service'
    import editSmsCampaign from '@/components/SMSCampaignEdit.vue'
    import Alert from '@/components/Alert.vue'
    export default {
        components: { Alert, editSmsCampaign },
        data() {
            return {
                campaign: {},
                submitLoading: false,
                alert: {
                    show: false,
                    message: '',
                    type: null
                }
            }
        },
        computed: {
            getCurrentSMSCampaign() {
                return this.campaign ?? this.$store.getters.getCurrentSMSCampaign
            }
        },
        created() {
            this.fetchSMSCampaignById(this.$route.params.campaignId)
        },
        methods: {
            fetchSMSCampaignById(id) {
                smsCampaignService.getSMSCampaignById(id)
                    .then(resp => {
                        this.campaign = resp.data
                    })
                    .catch(err => {
                        if (err.status === 404) {
                            return this.returnToInfoList()
                        }
                        throw err
                    })
            },
            updateSmsCampaign(newCampaign) {
                this.submitLoading = true
                this.campaign = structuredClone(newCampaign)
                smsCampaignService.updateSMSCampaign(this.campaign).then(() => {
                    this.setAlert('Campaign Updated', 'success')
                    setTimeout(() => { this.$router.push(`/sms/${this.getCurrentSMSCampaign.id}`) }, 3000)
                }).catch(error => {
                    this.setAlert('Error updating the campaign' + error.response.data.message, 'error')
                }).finally(() => {
                    this.submitLoading = false
                })
            },
            returnToInfoList() {
                this.$router.push('/sms')
            },
            setAlert(message, type) {
                this.alert.show = true
                this.alert.message = message
                this.alert.type = type
            }
        }
    }
</script>

<style scoped>

.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
}

.edit-btn {
    text-transform: none !important;
    background: #00acd6 !important;
    color: white;
    margin: 15px;
    width: 90%;
}

.form-field {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
}

</style>
